import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdHeartHalf } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import {
  STR_FIND_MATCH,
  STR_LATEST_ARTICLES,
  STR_MENU_ARTICLES,
  STR_MENU_DATING,
  STR_MENU_STORIES,
  STR_MENU_UTILITIES,
  STR_MORE_ARTICLES,
  STR_NO_DATA_FOUND,
  STR_PURCHASE_SUBSCRIPTION_PACKAGE
} from "../Strings";
import OneDatingFeed from '../ones/OneDateFeed';
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';



export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getDatingFeed();
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])



  if (ready) {
    if (
      appContext.auth && 
      appContext.currentUserData &&
      appContext.currentUserData.subscriptionStatus === 'active'
    ) {
      return (
        <>
          <div
            className="Fab"
            onClick={() => {
              appContext.navTo({
                item: 'view',
                subItem: 'find-match',
              })
            }}
          >
            <IoMdHeartHalf size={32} /> <br /> {STR_FIND_MATCH[appContext.language]}
          </div>

          <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "scroll",
              paddingBottom: "80px",
            }}
            className="mNoScrollBar"
          >
            <div className="container">

              <h6 className="mSectionTitle">
                {STR_MENU_DATING[appContext.language]}
              </h6>

              {
                (appContext.datingFeed && appContext.datingFeed.length > 0) ?
                  appContext.datingFeed.map((item, i) => {
                    return (
                      <OneDatingFeed key={i} data={item} />
                    )
                  })
                  :
                  <h6>
                    {STR_NO_DATA_FOUND[appContext.language]}
                  </h6>
              }
            </div>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div
            className="Fab"
            onClick={() => {
              if(appContext.auth && appContext.currentUserData) {
                appContext.tellPurchaseMessage();
              } else {
                appContext.navTo({
                  item: 'view',
                  subItem: 'login',
                })
              }
            }}
          >
            <IoMdHeartHalf size={32} /> <br /> {STR_FIND_MATCH[appContext.language]}
          </div>
          <div className="container">

            <h6 className="mSectionTitle">
              {STR_MENU_DATING[appContext.language]}
            </h6>

            <SubscriptionExpiredWidget />

            {
              (appContext.datingFeed && appContext.datingFeed.length > 0) ?
                appContext.datingFeed.map((item, i) => {
                  if (Number(item.id) < 12) {
                    return (
                      <OneDatingFeed key={i} data={item} />
                    )
                  }
                })
                :
                <h6>
                  {STR_NO_DATA_FOUND[appContext.language]}
                </h6>
            }
          </div>
        </>
      )
    }

  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}